import { AbstractVisitor } from "./Visitor";
/**
 * Visitor implementation to resolve Alias and PluginChains to normal Plugins AST
 * @public
 */
export class AliasAstExtensionVisitor extends AbstractVisitor {
    constructor(registry) {
        super();
        this.registry = registry;
    }
    visitPlugin(plugin) {
        this.resolve(plugin);
    }
    resolve(plugin) {
        if (this.registry.isAlias(plugin.plugin)) {
            this.resolveAlias(plugin);
        }
        // there can be an alias for plugin chain, so we check for plugin chain last.
        if (this.registry.isPluginChain(plugin.plugin)) {
            this.resolveChain(plugin);
        }
    }
    resolveAlias(plugin) {
        const aliasPlugin = this.registry.getAlias(plugin.plugin);
        plugin.plugin = aliasPlugin.name;
        plugin.parameter = Object.assign({}, aliasPlugin.parameter, plugin.parameter);
        // an alias can be an alias itself
        if (this.registry.isAlias(plugin.plugin)) {
            this.resolveAlias(plugin);
        }
    }
    resolveChain(plugin) {
        const chainFactory = this.registry.getPluginChain(plugin.plugin);
        let chain = chainFactory(plugin.parameter || {});
        plugin.plugin = chain.plugin;
        // parameter already merged by the chain factory, so we can assign them here without any merging
        plugin.parameter = chain.parameter;
        if (this.registry.isAlias(plugin.plugin)) {
            this.resolveAlias(plugin);
        }
        const lastPlugin = plugin;
        while (chain.pipe !== undefined) {
            const p = {
                plugin: chain.pipe.plugin,
                parameter: chain.pipe.parameter || {},
                piped: []
            };
            p.piped = lastPlugin.piped;
            lastPlugin.piped = [p];
            this.resolve(p);
            chain = chain.pipe;
        }
    }
}
//# sourceMappingURL=AliasAstExtensionVisitor.js.map